/*
 * @Author: yang
 * @Date: 2024-07-16 10:28:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-23 17:37:21
 * @Description: 碳转换设备接口
 */


import request from '@/utils/request'
let baseUrl ='/carbon/equipment'

/**
 * @description: 获取碳转换设备模块列表
 * @return {*}
 */
export async function listcarbonTools(data) {
    return await request({
        url: baseUrl+'/listPage',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}

/**
 * @description: 添加碳转换设备
 * @return {*}
 */
export async function addcarbonTools(data) {
    return await request({
        url: baseUrl+'/add',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}

/**
 * @description: 编辑碳转换设备
 * @return {*}
 */
export async function editcarbonTools(data) {
    return await request({
        url: baseUrl+'/update',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}

/**
 * @description: 批量删除考勤信息
 * @return {*}
 */
export async function delcarbonTools(data) {
    return await request({
        url: baseUrl+'/deleteBatch',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}




